import { ReactElement } from 'react'
import { useSnackbar } from '@ui/snackbar'
import Results2ActionBar from '../../Results2ActionBar'
import { UNSAVED_BEMESSUNG_NAV_SNACKBAR_KEY } from '../../Results2DetailPane/constants'

interface Props {
  isSaving: boolean
  /** Schubverbinder changed but not yet saved. */
  isDirty: boolean
  disabled: boolean
  onSave: () => void
  onRevert: () => void
}

/**
 * Footer of the Schubanker detail pane: a changed Schubverbinder is only saved here (the checks
 * are recomputed for it) or dropped via "Rückgängig"; until then the check table previews it.
 */
const ShearAnchorSaveRow = ({
  isSaving,
  isDirty,
  disabled,
  onSave,
  onRevert,
}: Props): ReactElement => {
  const { closeSnackbar } = useSnackbar()

  return (
    <Results2ActionBar
      status={isSaving ? 'saving' : isDirty ? 'dirty' : 'saved'}
      statusLabel={
        isSaving ? 'Wird gespeichert…' : isDirty ? 'Ungespeicherte Änderungen' : 'Gespeichert'
      }
      saveDisabled={!isDirty || isSaving || disabled}
      revertDisabled={!isDirty || isSaving || disabled}
      onSave={() => {
        onSave()
        closeSnackbar(UNSAVED_BEMESSUNG_NAV_SNACKBAR_KEY)
      }}
      onRevert={() => {
        onRevert()
        closeSnackbar(UNSAVED_BEMESSUNG_NAV_SNACKBAR_KEY)
      }}
      saveDataCy="shear-anchor-detail-save-btn"
      revertDataCy="shear-anchor-detail-revert-btn"
    />
  )
}

export default ShearAnchorSaveRow
